import UnitStruct from "@/redux/actions/struct/implemented/UnitStruct";
import classNames from "classnames";
import ModalManager from "../../../../../../components/ModalComponent/ModalManager";
import TablePage from "../../../../../../configurable/layouts/TablePageLayout/TablePage";
import i18n from "../../../../../../i18n";
import { AssetTypes } from "../../../../../../model/AssetTypes";
import { renderCellValue } from "../../../../../../modules/abstract-ui/data/table/TableUtils";
import BFButton from "../../../../../../modules/abstract-ui/general/Button/BFButton";
import LanguageService from "../../../../../../services/LanguageService";
import { RAC_TABLE_INVOICE_TYPES_COST_CENTER } from "../../../RACAppConstants";
import {
  RACInvoiceType,
  RACInvoiceTypeCostCenter,
} from "../../../RACInterfaces";
import "./RACInvoiceTypeCostCenterList.scss";
import RACInvoiceTypeCostCenterForm from "./form/RACInvoiceTypeCostCenterForm";

interface RACCostCenterListProps {
  invoiceType?: RACInvoiceType;
}

const RACCostCenterList = (props: RACCostCenterListProps) => {
  const { invoiceType } = props;

  const openInvoiceTypeCostCenterForm = (
    invoiceType: RACInvoiceType,
    invoiceTypeCostCenter?: RACInvoiceTypeCostCenter
  ) => {
    ModalManager.show({
      size: "md",
      noPadding: true,
      backdrop: "static",
      content: (states, setStates, closeModal) => (
        <RACInvoiceTypeCostCenterForm
          invoiceType={invoiceType}
          invoiceTypeCostCenter={invoiceTypeCostCenter}
          onClose={closeModal}
        />
      ),
    });
  };

  const invoiceTypelabel = `${LanguageService.translateLabel(
    invoiceType.data.displayName
  )} (${UnitStruct.getUnit(invoiceType.data.type)?.data.label})`;

  return (
    <div className={classNames("rac-invoice-type-cost-center-list", "__card")}>
      <TablePage
        layout={{
          className: "rac-invoice-type-cost-center-table",
          pageHeader: (
            <div style={{ display: "flex" }}>
              <div className="invoice-type-title">{invoiceTypelabel}</div>
              <div className={`fill`} />
              <BFButton
                onClick={() => openInvoiceTypeCostCenterForm(invoiceType)}
              >
                {i18n.t("rac:CostCenter.Create", "Unterkategorie erstellen")}
              </BFButton>
            </div>
          ),
        }}
        table={{
          identifier: RAC_TABLE_INVOICE_TYPES_COST_CENTER,
          dataUrl: `/api/asset/${AssetTypes.InvoiceConfig.CostCenter}`,
          hover: true,
          reloadOnMount: true,
          onRowDoubleClick(node: RACInvoiceTypeCostCenter, index, ev, params) {
            openInvoiceTypeCostCenterForm(invoiceType, node);
          },
          columns: {
            "data.displayName": {
              label: i18n.t("Base.Unit"),
              sortable: true,
              flexWidth: 120,
              resizableOptions: {
                min: 40,
                max: 200,
              },
              resizable: true,
              render: (node: RACInvoiceTypeCostCenter, index, params) =>
                renderCellValue(
                  LanguageService.translateLabel(node.data.displayName)
                ),
            },
          },
          additionalMatchQuery: {
            type: "op",
            op: "eq",
            name: "data.parentInvoiceType",
            value: invoiceType?._id,
          },
        }}
      />
    </div>
  );
};

export default RACCostCenterList;
